var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DeviceAppBarPage",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "KPageContainer",
        { staticClass: "device-container" },
        [
          _c("HeaderWithOptions", {
            attrs: { headerText: _vm.coreString("facilitiesLabel") },
            scopedSlots: _vm._u([
              {
                key: "options",
                fn: function () {
                  return [
                    _c(
                      "KButtonGroup",
                      [
                        _vm.isAnyFacilityRegistered
                          ? _c("KButton", {
                              staticStyle: {
                                "margin-top": "16px",
                                "margin-bottom": "-16px",
                              },
                              attrs: { text: _vm.$tr("syncAllAction") },
                              on: {
                                click: function ($event) {
                                  _vm.showSyncAllModal = true
                                },
                              },
                            })
                          : _vm._e(),
                        _c("KButton", {
                          staticStyle: {
                            "margin-top": "16px",
                            "margin-bottom": "-16px",
                          },
                          attrs: {
                            text: _vm.getCommonSyncString(
                              "importFacilityAction"
                            ),
                            primary: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showImportModal = true
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm.activeFacilityTasks.length > 0
            ? _c("TasksBar", {
                attrs: {
                  tasks: _vm.activeFacilityTasks,
                  taskManagerLink: { name: "FACILITIES_TASKS_PAGE" },
                },
                on: { clearall: _vm.handleClickClearAll },
              })
            : _vm._e(),
          _c("CoreTable", {
            attrs: { dataLoading: _vm.loadingFacilities },
            scopedSlots: _vm._u([
              {
                key: "headers",
                fn: function () {
                  return [
                    _c("th", [_vm._v(_vm._s(_vm.coreString("facilityLabel")))]),
                  ]
                },
                proxy: true,
              },
              {
                key: "tbody",
                fn: function () {
                  return [
                    _vm.windowIsSmall
                      ? _c(
                          "tbody",
                          [
                            _vm._l(_vm.facilities, function (facility, idx) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    key: idx,
                                    staticStyle: { border: "none!important" },
                                  },
                                  [
                                    _c(
                                      "td",
                                      [
                                        _c("FacilityNameAndSyncStatus", {
                                          attrs: {
                                            facility: facility,
                                            isSyncing:
                                              _vm.facilityIsSyncing(facility),
                                            isDeleting:
                                              _vm.facilityIsDeleting(facility),
                                            syncHasFailed:
                                              facility.syncHasFailed,
                                            goToRoute: _vm.manageSync(
                                              facility.id
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c("tr", { key: idx + 10000 }, [
                                  _c(
                                    "td",
                                    { staticStyle: { padding: "0 0 16px 0" } },
                                    [
                                      _c(
                                        "KButtonGroup",
                                        {
                                          staticStyle: {
                                            "margin-left": "-16px",
                                            "margin-right": "-16px",
                                            "max-width": "100%",
                                          },
                                        },
                                        [
                                          _c("KButton", {
                                            attrs: {
                                              text: _vm.coreString(
                                                "syncAction"
                                              ),
                                              disabled:
                                                _vm.facilityIsSyncing(facility),
                                              appearance: "flat-button",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.facilityForSync = facility
                                              },
                                            },
                                          }),
                                          _c("KButton", {
                                            attrs: {
                                              hasDropdown: "",
                                              appearance: "flat-button",
                                              text: _vm.coreString(
                                                "optionsLabel"
                                              ),
                                              disabled:
                                                _vm.facilityIsSyncing(facility),
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "menu",
                                                  fn: function () {
                                                    return [
                                                      _c("KDropdownMenu", {
                                                        attrs: {
                                                          options:
                                                            _vm.facilityOptions(
                                                              facility
                                                            ),
                                                        },
                                                        on: {
                                                          select: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleOptionSelect(
                                                              $event.value,
                                                              facility
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            }),
                          ],
                          2
                        )
                      : _c(
                          "tbody",
                          _vm._l(_vm.facilities, function (facility, idx) {
                            return _c("tr", { key: idx }, [
                              _c(
                                "td",
                                [
                                  _c("FacilityNameAndSyncStatus", {
                                    attrs: {
                                      facility: facility,
                                      isSyncing:
                                        _vm.facilityIsSyncing(facility),
                                      isDeleting:
                                        _vm.facilityIsDeleting(facility),
                                      syncHasFailed: facility.syncHasFailed,
                                      goToRoute: _vm.manageSync(facility.id),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticClass: "button-col" },
                                [
                                  _c(
                                    "KButtonGroup",
                                    [
                                      _c("KButton", {
                                        attrs: {
                                          text: _vm.coreString("syncAction"),
                                          disabled:
                                            _vm.facilityIsSyncing(facility),
                                          appearance: "flat-button",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.facilityForSync = facility
                                          },
                                        },
                                      }),
                                      _c("KButton", {
                                        attrs: {
                                          hasDropdown: "",
                                          appearance: "flat-button",
                                          text: _vm.coreString("optionsLabel"),
                                          disabled:
                                            _vm.facilityIsSyncing(facility),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "menu",
                                              fn: function () {
                                                return [
                                                  _c("KDropdownMenu", {
                                                    attrs: {
                                                      options:
                                                        _vm.facilityOptions(),
                                                    },
                                                    on: {
                                                      select: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleOptionSelect(
                                                          $event.value,
                                                          facility
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ])
                          }),
                          0
                        ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          Boolean(_vm.facilityForRemoval)
            ? _c("RemoveFacilityModal", {
                attrs: { facility: _vm.facilityForRemoval },
                on: {
                  success: _vm.handleRemoveSuccess,
                  cancel: function ($event) {
                    _vm.facilityForRemoval = null
                  },
                },
              })
            : _vm._e(),
          _vm.showSyncAllModal
            ? _c("SyncAllFacilitiesModal", {
                attrs: { facilities: _vm.facilities },
                on: {
                  success: _vm.handleSyncAllSuccess,
                  cancel: function ($event) {
                    _vm.showSyncAllModal = false
                  },
                },
              })
            : _vm._e(),
          _vm.showImportModal
            ? _c("ImportFacilityModalGroup", {
                on: {
                  success: _vm.handleStartImportSuccess,
                  cancel: function ($event) {
                    _vm.showImportModal = false
                  },
                },
              })
            : _vm._e(),
          Boolean(_vm.facilityForRegister)
            ? [
                !_vm.kdpProject
                  ? _c("RegisterFacilityModal", {
                      attrs: {
                        facility: _vm.facilityForRegister,
                        displaySkipOption: false,
                      },
                      on: {
                        success: _vm.handleValidateSuccess,
                        cancel: _vm.clearRegistrationState,
                        skip: _vm.handleKDPSync,
                      },
                    })
                  : _c("ConfirmationRegisterModal", {
                      attrs: {
                        targetFacility: _vm.facilityForRegister,
                        projectName: _vm.kdpProject.name,
                        token: _vm.kdpProject.token,
                      },
                      on: {
                        success: _vm.handleConfirmationSuccess,
                        cancel: _vm.clearRegistrationState,
                      },
                    }),
              ]
            : _vm._e(),
          Boolean(_vm.facilityForSync)
            ? _c("SyncFacilityModalGroup", {
                attrs: { facilityForSync: _vm.facilityForSync },
                on: {
                  close: function ($event) {
                    _vm.facilityForSync = null
                  },
                  syncKDP: _vm.handleKDPSync,
                  syncPeer: _vm.handlePeerSync,
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }